if (!customElements.get('text-page-sticky-nav')) {
  class TextPageStickyNav extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.initialize(), { once: true });
        return;
      }

      this.initialize();
    }

    initialize() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.content = this.querySelector('[data-text-page-content]');
      this.navigation = this.querySelector('[data-text-page-navigation]');
      this.navigationList = this.querySelector('[data-text-page-navigation-list]');
      this.titleElement = this.querySelector('.text-page-sticky-nav__title');

      if (!this.content || !this.navigation || !this.navigationList) return;

      if (this.dataset.pageType === 'policy') {
        const nativePolicy = document.querySelector('[data-policy-native-content]');
        const nativeTitle = nativePolicy?.querySelector('.shopify-policy__title h1');
        const nativeBody = nativePolicy?.querySelector('.shopify-policy__body .rte');

        if (nativeTitle && this.titleElement) {
          this.titleElement.textContent = nativeTitle.textContent.trim();
          this.navigation.setAttribute('aria-label', `${this.titleElement.textContent} sections`);
        }

        if (nativeBody) {
          this.content.innerHTML = nativeBody.innerHTML;
          nativePolicy.remove();
        } else if (nativePolicy) {
          nativePolicy.hidden = false;
        }
      }

      this.headings = Array.from(this.content.querySelectorAll('h2'));

      if (this.dataset.pageType === 'policy') {
        const policySubheadings = Array.from(this.content.querySelectorAll('h3'));
        const policyStrongHeadings = Array.from(this.content.querySelectorAll('strong')).filter((heading) => {
          const text = heading.textContent.trim();
          return /^(overview|section\s+\d+\b)/i.test(text);
        });

        this.headings = Array.from(new Set([
          ...this.headings,
          ...policySubheadings,
          ...policyStrongHeadings
        ])).sort((first, second) => {
          const position = first.compareDocumentPosition(second);
          return position & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
        });
      }
      if (!this.headings.length) {
        this.navigation.hidden = true;
        return;
      }

      this.usedIds = new Set(
        Array.from(document.querySelectorAll('[id]'))
          .filter((element) => !this.headings.includes(element))
          .map((element) => element.id)
      );

      this.headings.forEach((heading, index) => {
        heading.id = this.getHeadingId(heading, index);

        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        link.dataset.textPageNavigationLink = '';

        item.appendChild(link);
        this.navigationList.appendChild(item);
      });
    }

    getHeadingId(heading, index) {
      if (heading.id && !this.usedIds.has(heading.id)) {
        this.usedIds.add(heading.id);
        return heading.id;
      }

      const baseId = heading.textContent
        .trim()
        .toLowerCase()
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '') || `section-${index + 1}`;

      let id = baseId;
      let suffix = 2;
      while (this.usedIds.has(id)) {
        id = `${baseId}-${suffix}`;
        suffix += 1;
      }

      this.usedIds.add(id);
      return id;
    }
  }

  customElements.define('text-page-sticky-nav', TextPageStickyNav);
}
